import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from '../shared.module';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';

@Component({
  standalone: true,
  selector: 'icu-from-to',
  templateUrl: 'from-to.component.html',
  imports: [SharedModule,NgxMatMomentModule,NgxMatDatetimePickerModule,NgxMatTimepickerModule],
  styleUrls: ['./from-to.component.css']
})
export class FromToComponent {
  @Input() fromDate?: string;
  @Input() toDate?: string;

  @Output() fromDateChange = new EventEmitter<string>();
  @Output() toDateChange = new EventEmitter<string>();
}
